<template>
  <div class="members-hero-container">
    <div class="hero-image"></div>
    <div class="text-container">
      <h1>MEMBERS ONLY REWARDS</h1>
      <p>
        Earn points with every purchase to unlock benefits like early access,
        free shipping, and exclusive concierge services.
      </p>
      <div class="button-container">
        <div v-if="isLoggedIn" class="account-buttons">
          <Button tag="a" :href="multipassAccount.url" theme="primary-light">
            Go to account
          </Button>
        </div>
        <template v-else>
          <Button
            type="button"
            theme="primary-light"
            @click="setSlideSignUp({ value: true, forceShow: true })"
          >
            REGISTER
          </Button>
          <Button
            type="button"
            theme="primary-light"
            @click="setSlideLogin(true)"
          >
            SIGN IN
          </Button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  name: "MembersHero",
  components: {
    Button,
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapState("auth", ["multipassAccount"]),
  },
  methods: {
    ...mapActions("app", ["setSlideLogin", "setSlideSignUp"]),
  },
};
</script>

<style lang="scss" scoped>
.members-hero-container {
  position: relative;
  text-align: center;
}
.hero-image {
  height: 90vh;
  background-position: top center;
  background-repeat: no-repeat;
  background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/image_1_1_876f4275-f757-4ecf-8017-6ed19aeabe83.jpg?v=1778001317");
  background-size: cover;

  @include respond-above(sm) {
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/image_1_1_876f4275-f757-4ecf-8017-6ed19aeabe83.jpg?v=1778001317");
  }

  @include respond-above(md) {
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/image_1_d9a50258-df71-4293-90b8-aaa3674a85b2.jpg?v=1774370192");
  }
  &::after {
    content: "";
    background: linear-gradient(
      180deg,
      rgba(89, 89, 89, 0) 0%,
      rgba(1, 1, 1, 0.6) 100%
    );
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 75%;
  }
}

.text-container {
  color: $color-white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  @include respond-above(md) {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    width: 660px;
    margin: 0 auto 60px;
    transform: none;
  }
}

h1 {
  @include editorial-headline(32px);
  margin: 0 0 16px;
  @include respond-above(md) {
    @include editorial-headline(64px);
  }
}

p {
  @include editorial-body(16px);
  margin: 0 0 28px;
  @include respond-above(md) {
    @include editorial-body(16px);
  }
}

.button-container {
  display: flex;
  justify-content: center;
  column-gap: 10px;
}
</style>
